<template>
  <v-app class="container">
    <barra />
    <v-card v-if="datos" class="text-center">
      <v-card-title class="grey lighten-4 change-font" primary-title>
        <v-container fluid grid-list-xl>
          <v-layout justify-space-between>
            <v-flex xs6 md6 align-start>Avance PMI por punto del acuerdo</v-flex>
            <v-flex></v-flex>
            <v-flex xs6 md6>Entidad: {{nombreentidad}}</v-flex>
          </v-layout>
        </v-container>
      </v-card-title>
      <v-card-text>
        <v-container v-if="datos.length>0">
          <v-layout row wrap>
            <v-flex sm4>% de avance general</v-flex>
            <v-flex sm4></v-flex>
            <v-flex sm4>% de avance de entidad</v-flex>
          </v-layout>
          <v-layout row wrap v-for="(item, index) in datos" :key="index">
            <v-flex sm4>
              <v-progress-linear
                :active="true"
                :background-opacity="0.18"
                :buffer-value="100"
                :height="40"
                :value="item.izquierdo"
                :color="item.color"
                style=" transform: rotate(180deg);"
                class="text-right"
              >
                <template v-slot="{ value }">
                  <strong
                    style=" font-size: large;transform: rotate(180deg);"
                  >{{ Intl.NumberFormat("es-CO", {minimumFractionDigits: 1}).format(value ) + " %" }}</strong>
                </template>
              </v-progress-linear>
            </v-flex>
            <v-flex sm4 style="height: 50px">{{item.nombre}}</v-flex>
            <v-flex sm4>
              <v-progress-linear
                :active="true"
                :background-opacity="0.18"
                :buffer-value="100"
                :height="40"
                :value="item.derecho"
                :color="item.color"
              >
                <template v-slot="{ value }">
                  <strong
                    style=" font-size: large"
                  >{{ Intl.NumberFormat("es-CO", {minimumFractionDigits: 1}).format(value ) + " %" }}</strong>
                </template>
              </v-progress-linear>
            </v-flex>
          </v-layout>
          <v-flex
            class="fechacorte"
            xs12
            v-if="gfechacorte!== null"
          >Fecha actualización: {{formato(gfechacorte.fechaactualizacion)}}</v-flex>
          <v-flex
            class="fechacorte"
            xs12
            v-if="gfechacorte!== null"
          >Fecha corte: {{formato(gfechacorte.fechacorte)}}</v-flex>
        </v-container>
        <v-container v-else>
          <p>{{gnodata}}</p>
        </v-container>
      </v-card-text>
    </v-card>
    <br />
    <v-card v-if="datosclasificacion" class="text-center">
      <v-card-title class="grey lighten-4 change-font" primary-title>
        <v-container fluid grid-list-xl>
          <v-layout justify-space-between>
            <v-flex xs6 md6 align-start>Avance PMI según clasificación</v-flex>
            <v-flex></v-flex>
            <v-flex xs6 md6>Entidad: {{nombreentidad}}</v-flex>
          </v-layout>
        </v-container>
      </v-card-title>
      <v-card-text>
        <v-container v-if="datosclasificacion.length>0">
          <v-layout row wrap>
            <v-flex sm4>% de avance general</v-flex>
            <v-flex sm4></v-flex>
            <v-flex sm4>% de avance de entidad</v-flex>
          </v-layout>
          <v-layout row wrap v-for="(item, index) in datosclasificacion" :key="index">
            <v-flex sm4>
              <v-progress-linear
                :active="true"
                :background-opacity="0.18"
                :buffer-value="100"
                :height="40"
                :value="item.izquierdo"
                :color="item.color"
                style=" transform: rotate(180deg);"
                class="text-right"
              >
                <template v-slot="{ value }">
                  <strong
                    style=" font-size: large;transform: rotate(180deg);"
                  >{{ Intl.NumberFormat("es-CO", {minimumFractionDigits: 1}).format(value ) + " %" }}</strong>
                </template>
              </v-progress-linear>
            </v-flex>
            <v-flex sm4 style="height: 50px">{{item.nombre}}</v-flex>
            <v-flex sm4>
              <v-progress-linear
                :active="true"
                :background-opacity="0.18"
                :buffer-value="100"
                :height="40"
                :value="item.derecho"
                :color="item.color"
              >
                <template v-slot="{ value }">
                  <strong
                    style=" font-size: large"
                  >{{ Intl.NumberFormat("es-CO", {minimumFractionDigits: 1}).format(value ) + " %" }}</strong>
                </template>
              </v-progress-linear>
            </v-flex>
          </v-layout>
        </v-container>
        <v-container v-else>
          <p>{{gnodata}}</p>
        </v-container>
      </v-card-text>
    </v-card>
  </v-app>
</template>
<script>
import barra from "@/components/content/barra-nav.vue";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
export default {
  data() {
    return {
      datos: [],
      datosclasificacion: [],
      nombreentidad: ""
    };
  },
  components: {
    barra
  },
  created() {
    this.cargardatos();
  },
  mounted() {},
  methods: {
    ...mapActions([
      "puntoTodos",
      "get_puntosentidad",
      "get_clasificacionesentidad",
      "get_clasificacionperiodo",
      "Getentidad",
      "get_fechacorteentidad"
    ]),
    llenardatospunto() {
      let puntos = this.gpuntos;
      let puntoscategoria = this.gpuntoscategoria;
      this.datos = [];
      if (puntos.length > 0 && puntoscategoria.length > 0) {
        for (let [, evalue] of Object.entries(puntoscategoria)) {
          let eobj = {
            derecho: evalue.avance,
            nombre: evalue.nombre,
            izquierdo: 0,
            color: evalue.color
          };
          let sec = puntos.filter(p => p.idpunto === evalue.idpunto)[0];
          if (sec !== undefined) {
            eobj.izquierdo = sec.avance;
          }
          this.datos.push(eobj);
        }
      }
    },
    llenardatosclasificacion() {
      let clasificaciones = this.gclasificaciones;
      let clasificacionescategoria = this.gclasificacionescategoria;
      this.datosclasificacion = [];
      if (clasificaciones.length > 0 && clasificacionescategoria.length > 0) {
        for (let [, evalue] of Object.entries(
          clasificacionescategoria.filter(p => p.visible === true)
        )) {
          let eobj = {
            derecho: evalue.porcentajeAvance,
            nombre: evalue.nombre,
            izquierdo: 0,
            color: evalue.color
          };
          let sec = clasificaciones.filter(
            p => p.idclasificacion === evalue.idclasificacion
          )[0];
          if (sec !== undefined) {
            eobj.izquierdo = sec.porcentajeAvance;
          }

          this.datosclasificacion.push(eobj);
        }
      }
    },
    cargardatos() {
      let usuario = this.datousuario();
      this.puntoTodos({
        params: {
          periodoId: this.gperiodo
        }
      });
      this.get_fechacorteentidad({
        params: {
          idperiodo: this.gperiodo,
          identidad: usuario.identidad
        }
      });
      this.get_clasificacionperiodo({
        params: {
          periodoId: this.gperiodo
        }
      });
      this.get_puntosentidad({
        params: {
          periodoId: this.gperiodo,
          identidad: usuario.identidad
        }
      });
      this.Getentidad();
      this.get_clasificacionesentidad({
        params: {
          periodoId: this.gperiodo,
          identidad: usuario.identidad
        }
      });
    },
    datousuario() {
      return JSON.parse(unescape(localStorage.usuario));
    },
    formato(value) {
      if (value) {
        return moment(String(value)).format("DD/MM/YYYY");
      }
    }
  },
  computed: {
    ...mapGetters([
      "gpuntos",
      "gpuntoscategoriaentidad",
      "gclasificaciones",
      "gclasificacionescategoriaentidad",
      "gentidades",
      "gfechacorte"
    ]),
    ...mapGetters("barra", ["gperiodo"]),
    ...mapGetters("mensaje", ["gnodata"])
  },
  watch: {
    gpuntos: function() {
      this.llenardatospunto();
    },
    gpuntoscategoria: function() {
      this.llenardatospunto();
    },
    gclasificaciones: function() {
      this.llenardatosclasificacion();
    },
    gclasificacionescategoria: function() {
      this.llenardatosclasificacion();
    },
    gperiodo: function() {
      this.cargardatos();
    },
    gentidades: function() {
      let usuario = this.datousuario();
      this.nombreentidad = this.gentidades.filter(
        p => p.identidad === usuario.identidad
      )[0].nombre;
    }
  }
};
</script>